import type {
  UsersSelectOptionItemData,
  UsersSelectOptionItemValue,
  UsersSelectProps,
} from "./users-select.type";

import { useTranslation } from "react-i18next";

import QueryableSelect from "@/modules/queryable-select";

import UsersSelectOption from "./users-select-option";

const UsersSelect = (props: UsersSelectProps) => {
  const { t } = useTranslation();
  const label = t("global:userPlural");

  return (
    <QueryableSelect<UsersSelectOptionItemValue, UsersSelectOptionItemData>
      name="users"
      model="users"
      filterBy="name"
      fields={["id", "name", "email"]}
      mode="multiple"
      optionFormat={UsersSelectOption}
      label={label}
      placeholder={label}
      dataTestId="usersSelectId"
      {...props}
    />
  );
};

export default UsersSelect;
